// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"0ac2922fbbc8f98d365b","149":"54d565a0bdfa984ace59"}[chunkId] + ".js";
};